// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23h_x","input":"styles_input__3oZJg"};